export default {
  name: 'custom_text_field',
  component_path: 'modules/procedures/blocks/BlockInputText'
}